module.exports = __webpack_public_path__ + "static/media/avatarTabela.97b7bc74.svg";